import { render, staticRenderFns } from "./ybStockTotal.vue?vue&type=template&id=5f2ac03c"
import script from "./ybStockTotal.vue?vue&type=script&lang=js"
export * from "./ybStockTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports